<template>
  <div class="separation-anxiety-card">
    <va-card title="Tackling Separation Anxiety">
      <separation-anxiety-description />
      <div class="initial-consultation">
        <span class="display-3">Initial consultation</span>
        <span class="display-4">$140</span>
        <div>
          The initial consultation is the first step to determining if your dog has separation anxiety/isolation distress and outlining the plan to tackle it.
        </div>
        <div>
          What's included:
          <ul>
            <li>90 minute remote session with Nadia</li>
            <li>Discussion of your training goals and what has and hasn't been working for you so far</li>
            <li>Determining your dog's absence threshold</li>
            <li>Discussion about technology needed for training plan and how to set everything up</li>
            <li>Discussion of expectations and next steps</li>
            <li>Recording of the session, notes, and follow-up handouts</li>
          </ul>
        </div>
      </div>
      <div class="one-month-package">
        <span class="display-3">4-week package</span>
        <span class="display-4">$500</span>
        <div>
          In this 4 week package, you will get the skills and data to systematically tackle your dog's separation anxiety.
        </div>
        <div>
          What's included:
          <ul>
            <li>4 60-minute reassessments to determine your dog's progress and new thresholds</li>
            <li>Customized daily homework</li>
            <li>Unlimited mid-week support via messaging app of your choice</li>
            <li>Recordings of the reassessments, notes, and follow-up handouts</li>
            <li>Support, cheerleading, & coaching</li>
          </ul>
        </div>
      </div>
      <va-button @click="openModal()" class="request-button">Request to enroll</va-button>
    </va-card>
    <va-modal v-model="showModal" title="Request for initial consultation" :message="modalMessage"
      position="top" size="large" hide-default-actions>
      <separation-anxiety-form @sent-request="closeModal" />
      <div class="cancel-button" style="display: flex; justify-content: center;">
        <va-button flat color="gray" @click="closeModal">
          Cancel
        </va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import SeparationAnxietyDescription from '../sub-components/SeparationAnxietyDescription.vue'
import SeparationAnxietyForm from '../forms/SeparationAnxietyForm'

export default {
  name: 'separation-anxiety-card',
  components: {
    SeparationAnxietyDescription,
    SeparationAnxietyForm,
  },
  data () {
    return {
      showModal: false,
      modalMessage: 'Request for separation anxiety initial consultation',
    }
  },
  methods: {
    openModal () {
      this.modalMessage = 'Request for separation anxiety initial consultation'
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
  },
}
</script>

<style scoped lang="scss">
.separation-anxiety-card {
  div {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
  }

  ul {
    margin-top: 2rem;
    margin-left: 2rem;

    li {
      list-style: circle;

      .italic {
        margin-top: 0;
        font-style: italic;
      }
    }
  }

  .initial-consultation {
    margin-top: 2rem;
  }

  .request-button,
  .one-month-package {
    margin-top: 2rem;
  }
}
</style>
